export const ROLE_BEGIN_WRITE_DATA = 'ROLE/BEGIN_WRITE_DATA';
export const ROLE_COMPLETE_WRITE_DATA = 'ROLE/COMPLETE_WRITE_DATA';
export const ROLE_REQUEST_DATA = 'ROLE/REQUEST_DATA';
export const RECEIVE_ROLES = 'ROLE/RECEIVE_ROLES';
